import type { ReactNode } from "react";
import { GRAD_TEXT } from "./tokens";

/** Inline gradient-clipped text — used inside section titles. */
export default function GradText({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return <span className={`${GRAD_TEXT} ${className}`}>{children}</span>;
}
